import { addLocale, localeOptions } from 'primereact/api';

/**
 * Locale en español del calendario de PrimeReact para el módulo. El admin no
 * tiene ninguno configurado (ni `addLocale` ni `PrimeReactProvider`): el botón
 * de «Otra semana» se anunciaba «Choose Date» y el panel salía en inglés, con
 * la semana empezando en domingo. La semana retail es de LUNES a domingo.
 *
 * Con nombre propio (no `es`) para no cambiar a nadie más del panel; se
 * registra una sola vez y no toca el locale global (`locale()` sigue en `en`).
 */
export const LOCALE_METAS = 'es-metas';

export function registrarLocaleMetas(): string {
  if (!localeOptions(LOCALE_METAS)) {
    addLocale(LOCALE_METAS, {
      firstDayOfWeek: 1,
      dateFormat: 'dd/mm/yy',
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthNames: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
      ],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Limpiar',
      weekHeader: 'Sem',
      chooseDate: 'Elegir fecha',
      chooseMonth: 'Elegir mes',
      chooseYear: 'Elegir año',
      prevMonth: 'Mes anterior',
      nextMonth: 'Mes siguiente',
      prevYear: 'Año anterior',
      nextYear: 'Año siguiente',
      prevDecade: 'Década anterior',
      nextDecade: 'Década siguiente',
    });
  }
  return LOCALE_METAS;
}
